import { render } from "./SnehaSparshamReport.vue?vue&type=template&id=1fd0f4cd&scoped=true"
import script from "./SnehaSparshamReport.vue?vue&type=script&lang=js"
export * from "./SnehaSparshamReport.vue?vue&type=script&lang=js"

import "./SnehaSparshamReport.vue?vue&type=style&index=0&id=1fd0f4cd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd0f4cd"]])

export default __exports__